<template>
  <div class="flex flex-col flex-1">
    <MTab v-model="currentTab" position="left">
      <MTabPane key="invoice" :tab="`${$tc('invoice', 2)}`">
        <InvoiceContainer
          :key="currentTab"
          :disabled="disabled"
          :has-actions="!disabled"
          v-bind="$attrs"
          @refresh="$emit('refresh', ['settlements'])"
        />
      </MTabPane>
      <MTabPane key="payment" :tab="`${$tc('payment', 2)}`">
        <PaymentContainer
          :key="currentTab"
          :disabled="disabled"
          :has-actions="!disabled"
          v-bind="$attrs"
          @refresh="$emit('refresh', ['settlements', 'payment'])"
        />
      </MTabPane>
    </MTab>
  </div>
</template>

<script>
import InvoiceContainer from './invoice-container'
import PaymentContainer from './payment-container'
export default {
  name: 'SettlementTab',
  components: { InvoiceContainer, PaymentContainer },
  props: {
    disabled: { type: Boolean, default: false },
    defaultActive: { type: String, default: undefined },
  },
  data() {
    return {
      currentTab: this.defaultActive ? this.defaultActive : 'invoice',
    }
  },
}
</script>
